import { render, staticRenderFns } from "./PdfmdpjanIndextab2.vue?vue&type=template&id=6d6c5ba4"
import script from "./PdfmdpjanIndextab2.vue?vue&type=script&lang=js"
export * from "./PdfmdpjanIndextab2.vue?vue&type=script&lang=js"
import style0 from "./PdfmdpjanIndextab2.vue?vue&type=style&index=0&id=6d6c5ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports